export default function sortByMultipleKey(keys) {
    return function (a, b) {
        if (keys.length == 0) return 0; // force to equal if keys run out
        var key = keys[0]; // take out the first key
        if (a[key] < b[key]) return -1; // will be 1 if DESC
        else if (a[key] > b[key]) return 1; // will be -1 if DESC
        else return sortByMultipleKey(keys.slice(1))(a, b);
    }
}